import { createSelector } from '@reduxjs/toolkit';
export const facetRequestSelector = createSelector((state, facetId) => ({
    facetRequestSelector: state.commerceFacetSet[facetId],
}), ({ facetRequestSelector }) => {
    return facetRequestSelector?.request;
});
